// extracted by extract-css-chunks-webpack-plugin
module.exports = {"box":"box-2BceedCf","footer":"footer-3A2Z-HMf"};